import * as React from "react";

function SvgCurve1Inverted(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 200" {...props}><path d="M1610 78.3c-187 54.4-476.7 89.3-802 89.3-334.7 0-631.8-37-818-94.1v136.8h1620v-132z" /></svg>;
}

export default SvgCurve1Inverted;